module.exports = __webpack_public_path__ + "html/week7_033b0421ff8c67019dd86e0ea4fe2bfd.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week7.html
// module id = XKv6
// module chunks = 51